import request from '@/services/interceptor.js'

export const get_elencoPreventivi = () => {
    return request({
        url: '/preventivi/list',
        method: 'get',
        loadingBar: true
    })
};